"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Base;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _extractProps = require("~/helpers/extractProps");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _modelUtils = require("~/utils/modelUtils");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _commandPaletteHelpers = require("~/helpers/commandPaletteHelpers");
const _catchError = require("~/helpers/catchError");
const _scriptHelper = require("~/helpers/scriptHelper");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('Base');
let Base = class Base {
    static castType(base) {
        return base && new Base(base);
    }
    static async populateManagedAppInfo(_base) {
        return;
    }
    static async createProject(base, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(base, [
            'id',
            'title',
            'prefix',
            'description',
            'is_meta',
            'status',
            'meta',
            'color',
            'order',
            'version',
            'managed_app_master',
            'managed_app_id',
            'managed_app_version_id',
            'auto_update',
            'is_sandbox_master',
            'is_sandbox'
        ]);
        if (!insertObj.order) {
            // get order value
            insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.PROJECT, {});
        }
        // stringify meta
        if (insertObj.meta) {
            insertObj.meta = (0, _modelUtils.stringifyMetaProp)(insertObj);
        } else if (!('meta' in insertObj)) {
            insertObj.meta = '{"iconColor":"#36BFFF"}';
        }
        // set as db if not set
        if (!insertObj.type) {
            insertObj.type = 'database';
        }
        insertObj.fk_workspace_id = _Noco.default.ncDefaultWorkspaceId;
        const createdBase = await ncMeta.metaInsert2(_globals.RootScopes.BASE, _globals.RootScopes.BASE, _globals.MetaTable.PROJECT, insertObj);
        const context = {
            workspace_id: createdBase.fk_workspace_id,
            base_id: createdBase.id
        };
        for (const source of base.sources){
            var _source_config;
            await _models.Source.createBase(context, _extends({
                type: (_source_config = source.config) == null ? void 0 : _source_config.client
            }, source, {
                baseId: createdBase.id
            }), ncMeta);
        }
        await _NocoCache.default.del('root', _globals.CacheScope.INSTANCE_META);
        await _models.DataReflection.grantBase(base.fk_workspace_id, base.id, ncMeta);
        (0, _commandPaletteHelpers.cleanCommandPaletteCache)(context.workspace_id).catch(()=>{
            logger.error('Failed to clean command palette cache');
        });
        return this.getWithInfo(context, createdBase.id, true, ncMeta).then(async (base)=>{
            await _NocoCache.default.appendToList({
                workspace_id: base.fk_workspace_id,
                base_id: null
            }, _globals.CacheScope.PROJECT, [
                base.fk_workspace_id
            ], `${_globals.CacheScope.PROJECT}:${base.id}`);
            return base;
        });
    }
    static async list(workspaceId, ncMeta = _Noco.default.ncMeta) {
        // todo: pagination
        const cachedList = workspaceId ? await _NocoCache.default.getList({
            workspace_id: workspaceId,
            base_id: null
        }, _globals.CacheScope.PROJECT, [
            workspaceId
        ]) : {
            list: [],
            isNoneList: false
        };
        let { list: baseList } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !baseList.length) {
            baseList = await ncMeta.metaList2(_globals.RootScopes.BASE, _globals.RootScopes.BASE, _globals.MetaTable.PROJECT, {
                xcCondition: {
                    _and: [
                        ...workspaceId ? [
                            {
                                fk_workspace_id: {
                                    eq: workspaceId
                                }
                            }
                        ] : [],
                        {
                            _or: [
                                {
                                    deleted: {
                                        eq: false
                                    }
                                },
                                {
                                    deleted: {
                                        eq: null
                                    }
                                }
                            ]
                        }
                    ]
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList({
                workspace_id: workspaceId,
                base_id: null
            }, _globals.CacheScope.PROJECT, [
                workspaceId
            ], baseList);
        }
        const promises = [];
        const castedProjectList = baseList.filter((p)=>p.deleted === 0 || p.deleted === false || p.deleted === null).sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity)).map((p)=>{
            const base = this.castType(p);
            promises.push(base.getSources(false, ncMeta));
            return base;
        });
        await Promise.all(promises);
        return castedProjectList;
    }
    // @ts-ignore
    static async get(context, baseId, ncMeta = _Noco.default.ncMeta) {
        let baseData = baseId && await _NocoCache.default.get({
            workspace_id: context.workspace_id,
            base_id: null
        }, `${_globals.CacheScope.PROJECT}:${baseId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!baseData) {
            baseData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, {
                id: baseId,
                deleted: false
            });
            if (baseData) {
                baseData.meta = (0, _modelUtils.parseMetaProp)(baseData);
                await _NocoCache.default.set({
                    workspace_id: baseData.fk_workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT}:${baseId}`, baseData);
            }
        } else {
            if (baseData.deleted) {
                baseData = null;
            }
        }
        const base = this.castType(baseData);
        if (base && base.managed_app_id) {
            await this.populateManagedAppInfo(base);
        }
        return base;
    }
    async getSources(includeConfig = true, ncMeta = _Noco.default.ncMeta) {
        const sources = await _models.Source.list({
            workspace_id: this.fk_workspace_id,
            base_id: this.id
        }, {
            baseId: this.id
        }, ncMeta);
        this.sources = sources;
        if (!includeConfig) {
            sources.forEach((s)=>{
                s.config = undefined;
                s.integration_config = undefined;
            });
        }
        return sources;
    }
    // @ts-ignore
    static async getWithInfo(context, baseId, includeConfig = true, ncMeta = _Noco.default.ncMeta) {
        let baseData = baseId && await _NocoCache.default.get({
            workspace_id: context.workspace_id,
            base_id: null
        }, `${_globals.CacheScope.PROJECT}:${baseId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!baseData) {
            baseData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, {
                id: baseId,
                deleted: false
            });
            if (baseData) {
                baseData.meta = (0, _modelUtils.parseMetaProp)(baseData);
                await _NocoCache.default.set({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT}:${baseId}`, baseData);
            }
            if (baseData == null ? void 0 : baseData.uuid) {
                await _NocoCache.default.set({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:${baseData.uuid}`, baseId);
            }
        } else {
            if (baseData == null ? void 0 : baseData.deleted) {
                baseData = null;
            }
        }
        if (baseData) {
            const base = this.castType(baseData);
            if (base.managed_app_id) {
                await this.populateManagedAppInfo(base);
            }
            await base.getSources(includeConfig, ncMeta);
            return base;
        }
        return null;
    }
    // @ts-ignore
    static async softDelete(context, baseId, ncMeta = _Noco.default.ncMeta) {
        const base = await this.get(context, baseId, ncMeta);
        await this.clearConnectionPool(context, baseId, ncMeta);
        if (base) {
            // delete <scope>:<title>
            // delete <scope>:<uuid>
            // delete <scope>:ref:<titleOfId>
            await _NocoCache.default.del({
                workspace_id: base.fk_workspace_id,
                base_id: null
            }, [
                `${_globals.CacheScope.PROJECT_ALIAS}:${base.title}`,
                `${_globals.CacheScope.PROJECT_ALIAS}:${base.uuid}`,
                `${_globals.CacheScope.PROJECT_ALIAS}:ref:${base.title}`,
                `${_globals.CacheScope.PROJECT_ALIAS}:ref:${base.id}`
            ]);
        }
        await _NocoCache.default.del('root', _globals.CacheScope.INSTANCE_META);
        // remove item in cache list
        await _NocoCache.default.deepDel({
            workspace_id: context.workspace_id,
            base_id: null
        }, `${_globals.CacheScope.PROJECT}:${baseId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        _models.CustomUrl.bulkDelete({
            base_id: baseId
        }, ncMeta).catch(()=>{
            logger.error(`Failed to delete custom urls of baseId: ${baseId}`);
        });
        await _models.DataReflection.revokeBase(base.fk_workspace_id, base.id, ncMeta);
        await _models.MCPToken.bulkDelete({
            base_id: baseId
        }, ncMeta);
        await _models.FileReference.bulkDelete(context, {
            base_id: baseId
        }, ncMeta);
        (0, _commandPaletteHelpers.cleanCommandPaletteCache)(context.workspace_id).catch(()=>{
            logger.error('Failed to clean command palette cache');
        });
        (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
            logger.error('Failed to clean base schema cache for workspace');
        });
        // set meta
        return await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, {
            deleted: true
        }, baseId);
    }
    // @ts-ignore
    static async update(context, baseId, base, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(base, [
            'title',
            'prefix',
            'status',
            'description',
            'meta',
            'color',
            'deleted',
            'order',
            'sources',
            'uuid',
            'password',
            'roles',
            'version',
            'managed_app_master',
            'managed_app_id',
            'managed_app_version_id',
            'auto_update',
            'is_sandbox_master',
            'is_sandbox'
        ]);
        // stringify meta
        if (updateObj.meta) {
            updateObj.meta = (0, _modelUtils.stringifyMetaProp)(updateObj);
        }
        if (+updateObj.version !== _nocodbsdk.BaseVersion.V3) {
            // we do not allow downgrade from V3 to previous versions
            delete updateObj.version;
        }
        // get existing cache
        const key = `${_globals.CacheScope.PROJECT}:${baseId}`;
        let o = await _NocoCache.default.get({
            workspace_id: context.workspace_id,
            base_id: null
        }, key, _globals.CacheGetType.TYPE_OBJECT);
        if (o) {
            // update data
            // new uuid is generated
            if (o.uuid && updateObj.uuid && o.uuid !== updateObj.uuid) {
                await _NocoCache.default.del({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:${o.uuid}`);
                await _NocoCache.default.set({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:${updateObj.uuid}`, baseId);
            }
            // disable shared base
            if (o.uuid && updateObj.uuid === null) {
                await _NocoCache.default.del({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:${o.uuid}`);
            }
            if (o.title && updateObj.title && o.title !== updateObj.title) {
                await _NocoCache.default.del({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:${o.title}`);
                await _NocoCache.default.set({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:${updateObj.title}`, baseId);
            }
            o = _extends({}, o, updateObj);
            await _NocoCache.default.del('root', _globals.CacheScope.INSTANCE_META);
            // set cache
            await _NocoCache.default.set({
                workspace_id: context.workspace_id,
                base_id: null
            }, key, o);
        }
        (0, _commandPaletteHelpers.cleanCommandPaletteCache)(context.workspace_id).catch(()=>{
            logger.error('Failed to clean command palette cache');
        });
        (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
            logger.error('Failed to clean base schema cache for base');
        });
        if ('meta' in updateObj) {
            updateObj.meta = (0, _modelUtils.stringifyMetaProp)(updateObj);
        }
        // set meta
        return await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, updateObj, baseId);
    }
    // Todo: Remove the base entry from the connection pool in NcConnectionMgrv2
    static async delete(context, baseId, ncMeta = _Noco.default.ncMeta) {
        const base = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, baseId);
        if (!base) {
            _catchError.NcError.baseNotFound(baseId);
        }
        const users = await _models.BaseUser.getUsersList(context, {
            base_id: baseId,
            include_ws_deleted: true
        }, ncMeta);
        for (const user of users){
            await _models.BaseUser.delete(context, baseId, user.id, ncMeta);
        }
        const sources = await _models.Source.list(context, {
            baseId,
            includeDeleted: true
        }, ncMeta);
        for (const source of sources){
            await source.delete(context, ncMeta);
        }
        await _models.DataReflection.revokeBase(base.fk_workspace_id, base.id, ncMeta);
        if (base) {
            // delete <scope>:<uuid>
            // delete <scope>:<title>
            // delete <scope>:ref:<titleOfId>
            await _NocoCache.default.del({
                workspace_id: base.fk_workspace_id,
                base_id: null
            }, [
                `${_globals.CacheScope.PROJECT_ALIAS}:${base.uuid}`,
                `${_globals.CacheScope.PROJECT_ALIAS}:${base.title}`,
                `${_globals.CacheScope.PROJECT_ALIAS}:ref:${base.title}`,
                `${_globals.CacheScope.PROJECT_ALIAS}:ref:${base.id}`
            ]);
        }
        await _NocoCache.default.deepDel({
            workspace_id: context.workspace_id,
            base_id: null
        }, `${_globals.CacheScope.PROJECT}:${baseId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        await _Noco.default.ncAudit.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.AUDIT, {
            base_id: baseId
        });
        _models.CustomUrl.bulkDelete({
            base_id: baseId
        }, ncMeta).catch(()=>{
            logger.error(`Failed to delete custom urls of baseId: ${baseId}`);
        });
        (0, _commandPaletteHelpers.cleanCommandPaletteCache)(context.workspace_id).catch(()=>{
            logger.error('Failed to clean command palette cache');
        });
        (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
            logger.error('Failed to clean base schema cache for base');
        });
        await _models.FileReference.bulkDelete(context, {
            base_id: baseId
        }, ncMeta);
        await _models.Extension.deleteByBaseId(context, baseId, ncMeta);
        return await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, baseId);
    }
    static async getByUuid(context, uuid, ncMeta = _Noco.default.ncMeta) {
        const baseId = uuid && await _NocoCache.default.get({
            workspace_id: context.workspace_id,
            base_id: null
        }, `${_globals.CacheScope.PROJECT_ALIAS}:${uuid}`, _globals.CacheGetType.TYPE_STRING);
        let baseData = null;
        if (!baseId) {
            baseData = await ncMeta.metaGet2(_globals.RootScopes.FULL_BYPASS, _globals.RootScopes.FULL_BYPASS, _globals.MetaTable.PROJECT, {
                uuid
            });
            if (baseData) {
                baseData.meta = (0, _modelUtils.parseMetaProp)(baseData);
                await _NocoCache.default.set({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:${uuid}`, baseData == null ? void 0 : baseData.id);
            }
        } else {
            return this.get(context, baseId, ncMeta);
        }
        return (baseData == null ? void 0 : baseData.id) && this.get(context, baseData == null ? void 0 : baseData.id, ncMeta);
    }
    static async getWithInfoByTitle(context, title, ncMeta = _Noco.default.ncMeta) {
        const base = await this.getByTitle(context, title, ncMeta);
        if (base) {
            await base.getSources(false, ncMeta);
        }
        return base;
    }
    static async getByTitle(context, title, ncMeta = _Noco.default.ncMeta) {
        const baseId = title && await _NocoCache.default.get({
            workspace_id: context.workspace_id,
            base_id: null
        }, `${_globals.CacheScope.PROJECT_ALIAS}:${title}`, _globals.CacheGetType.TYPE_STRING);
        let baseData = null;
        if (!baseId) {
            baseData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, {
                title,
                deleted: false
            });
            if (baseData) {
                baseData.meta = (0, _modelUtils.parseMetaProp)(baseData);
                await _NocoCache.default.set({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:${title}`, baseData == null ? void 0 : baseData.id);
            }
        } else {
            return this.get(context, baseId, ncMeta);
        }
        return (baseData == null ? void 0 : baseData.id) && this.get(context, baseData == null ? void 0 : baseData.id, ncMeta);
    }
    static async getByTitleOrId(context, titleOrId, ncMeta = _Noco.default.ncMeta) {
        const baseId = titleOrId && await _NocoCache.default.get({
            workspace_id: context.workspace_id,
            base_id: null
        }, `${_globals.CacheScope.PROJECT_ALIAS}:ref:${titleOrId}`, _globals.CacheGetType.TYPE_STRING);
        let baseData = null;
        if (!baseId) {
            baseData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, {
                deleted: false
            }, null, {
                _or: [
                    {
                        id: {
                            eq: titleOrId
                        }
                    },
                    {
                        title: {
                            eq: titleOrId
                        }
                    }
                ]
            });
            if (baseData) {
                // parse meta
                baseData.meta = (0, _modelUtils.parseMetaProp)(baseData);
                await _NocoCache.default.set({
                    workspace_id: context.workspace_id,
                    base_id: null
                }, `${_globals.CacheScope.PROJECT_ALIAS}:ref:${titleOrId}`, baseData == null ? void 0 : baseData.id);
            }
        } else {
            return this.get(context, baseId, ncMeta);
        }
        return (baseData == null ? void 0 : baseData.id) && this.get(context, baseData == null ? void 0 : baseData.id, ncMeta);
    }
    static async getWithInfoByTitleOrId(context, titleOrId, ncMeta = _Noco.default.ncMeta) {
        const base = await this.getByTitleOrId(context, titleOrId, ncMeta);
        if (base) {
            // parse meta
            base.meta = (0, _modelUtils.parseMetaProp)(base);
            await base.getSources(false, ncMeta);
        }
        return base;
    }
    static async clearConnectionPool(context, baseId, ncMeta = _Noco.default.ncMeta) {
        const base = await this.get(context, baseId, ncMeta);
        if (base) {
            const sources = await base.getSources(false, ncMeta);
            for (const source of sources){
                await _NcConnectionMgrv2.default.deleteAwait(source);
            }
        }
    }
    constructor(base){
        this.is_meta = false;
        Object.assign(this, base);
    }
};
